/* hgn-drop-queue.js — moved verbatim from snippets/hgn-drop-queue.liquid on 2026-09-14 (page-weight phase B:
   inline JS → theme asset, loaded synchronously at the same position so execution order and
   DOMContentLoaded timing are unchanged). 1 original <script> block(s), in order.
   EDIT THIS FILE, not the snippet. */

(function () {
  'use strict';

  if (window.HGN && window.HGN.dropQueue) return;

  var API_BASE = 'https://naildrop.holygrailnail.co';
  var TEMP_KEY = 'hgn_drop_queue_temp';    // guest / pre-subscriber scratch (NOT per-customer — mirrors hgn_wishlist_temp)
  var CRUMB_PREFIX = 'hgn-drop-participant:'; // per-customer "has a subscriber row" memory
  var QUEUE_CAP = 60;                      // worker-side cap, enforced client-side too
  var DROP_TIERS = ['classic', 'gels', 'press-ons'];

  /* Same customer-id resolution as hgn-kit-progress / hgn-shop-mode. */
  function currentCustomerId() {
    if (window.Shopify && window.Shopify.customer && window.Shopify.customer.id) {
      return String(window.Shopify.customer.id);
    }
    var node = document.querySelector('[data-customer-id]');
    if (node) {
      var id = node.getAttribute('data-customer-id');
      if (id && id !== 'anon') return id;
    }
    return 'anon';
  }
  function isLoggedIn() { return currentCustomerId() !== 'anon'; }

  function dropAvailable() {
    var sm = window.HGN && window.HGN.shopMode;
    return !!(sm && typeof sm.isDropAvailable === 'function' && sm.isDropAvailable());
  }

  /* Per-tier market gate — HGN_DROP_ENABLED mirrors HGN_KIT_ENABLED:
     raw `| json` booleans, only explicit false disables (null /
     undefined / true all count as enabled — boot-race tolerant). */
  function isTierEnabled(tier) {
    var map = window.HGN_DROP_ENABLED;
    if (map && map[tier] === false) return false;
    return true;
  }

  function clone(o) { return JSON.parse(JSON.stringify(o)); }

  /* Normalise one queue item into the canonical client shape —
     accepts worker rows (snake_case) and theme payloads (camelCase). */
  function normaliseItem(raw) {
    if (!raw) return null;
    var variantId = raw.variantId != null ? raw.variantId : raw.variant_id;
    if (variantId == null || variantId === '') return null;
    return {
      variantId:  String(variantId),
      productId:  String(raw.productId != null ? raw.productId : (raw.product_id != null ? raw.product_id : '')),
      handle:     raw.handle || '',
      title:      raw.title || '',
      image:      raw.image || '',
      priceCents: (function () {
        var v = raw.priceCents != null ? raw.priceCents : raw.price_cents;
        var n = parseInt(v, 10);
        return isFinite(n) ? n : null;
      })(),
      tier:       DROP_TIERS.indexOf(raw.tier) !== -1 ? raw.tier : (raw.tier || null),
      queueItemId: raw.queueItemId || raw.id || null,
      addedAt:    raw.addedAt || raw.added_at || null
    };
  }

  /* ───── Pre-queue (localStorage) ───── */
  function readTemp() {
    try {
      var raw = localStorage.getItem(TEMP_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed.map(normaliseItem).filter(Boolean);
    } catch (e) { return []; }
  }
  function writeTemp(items) {
    try {
      if (!items || items.length === 0) localStorage.removeItem(TEMP_KEY);
      else localStorage.setItem(TEMP_KEY, JSON.stringify(items));
    } catch (e) { /* quota / privacy mode — swallow */ }
  }

  /* ───── Lane focus (R2 — tier integrity is absolute) ─────
     A Nail Drop list is single-tier. The lane is:
       1. the SUBSCRIBER's contract tier (always wins — switching
          tiers is an Appstle Swap, P6, never a mixed queue), else
       2. the shopper's explicit pick from the Nail Drop entry modal,
          persisted in localStorage `hgn-drop-focus:<customerId|anon>`
          (kit-focus peer key pattern).
     `null` = no lane chosen yet — the entry modal is mandatory before
     drop-mode takeovers paint (there is NO "undecided" lane, unlike
     kit focus). Changes emit `hgn:drop:focus:change` {from,to}, the
     peer of hgn:kit:focus:change. */
  var FOCUS_PREFIX = 'hgn-drop-focus:';
  function focusKey() { return FOCUS_PREFIX + currentCustomerId(); }
  function getFocus() {
    var sub = (serverState && serverState.subscriber) || null;
    if (sub && sub.tier && DROP_TIERS.indexOf(sub.tier) !== -1) return sub.tier;
    try {
      var raw = localStorage.getItem(focusKey());
      if (DROP_TIERS.indexOf(raw) !== -1 && isTierEnabled(raw)) return raw;
    } catch (e) {}
    return null;
  }
  function setFocus(tier) {
    if (tier !== null && (DROP_TIERS.indexOf(tier) === -1 || !isTierEnabled(tier))) {
      return false;
    }
    var prev = getFocus();
    try {
      if (tier == null) localStorage.removeItem(focusKey());
      else localStorage.setItem(focusKey(), tier);
    } catch (e) {}
    var next = getFocus(); // subscriber tier still wins — may be unchanged
    if (prev !== next) {
      try {
        document.dispatchEvent(new CustomEvent('hgn:drop:focus:change', {
          detail: { from: prev, to: next }
        }));
      } catch (e) {}
      emitQueue('focus');
    }
    return true;
  }

  /* ───── Participation crumb ───── */
  function crumbKey() { return CRUMB_PREFIX + currentCustomerId(); }
  function hasParticipantCrumb() {
    try { return localStorage.getItem(crumbKey()) === '1'; } catch (e) { return false; }
  }
  function setParticipantCrumb() {
    try { localStorage.setItem(crumbKey(), '1'); } catch (e) {}
  }

  /* ───── In-memory state ─────
     `serverState` is the last-resolved /api/drop/state payload (or
     null before any fetch / for guests). `queue` is the CURRENT
     working queue: the server queue when a subscriber exists, the
     local pre-queue otherwise. */
  var serverState = null;
  var statePromise = null;
  var queue = readTemp();
  var usingServer = false;

  function emit(detail) {
    try {
      document.dispatchEvent(new CustomEvent('hgn:drop:change', { detail: detail }));
    } catch (e) {}
  }
  function emitQueue(action, extra) {
    emit(Object.assign({
      queue: clone(queue),
      action: action,
      scope: usingServer ? 'server' : 'local'
    }, extra || {}));
  }

  /* ───── Fetch helpers — wishlist client pattern (buy-buttons.liquid):
     credentials:'omit', JSON in/out, throw on !ok. ───── */
  function apiFetch(path, opts) {
    opts = opts || {};
    return fetch(API_BASE + path, {
      method: opts.method || 'GET',
      credentials: 'omit',
      headers: { 'Content-Type': 'application/json' },
      body: opts.body ? JSON.stringify(opts.body) : undefined
    }).then(function (res) {
      if (!res.ok) {
        /* Attach the parsed error body when there is one — the worker
           sends structured refusals (e.g. 400 {error:'wrong-tier',
           message}) that the UI must surface verbatim. */
        return res.json().catch(function () { return null; }).then(function (body) {
          var err = new Error('drop-api-' + res.status);
          err.status = res.status;
          err.body = body;
          throw err;
        });
      }
      return res.json();
    });
  }

  function adoptServerState(data) {
    serverState = data || null;
    var hasSubscriber = !!(data && data.subscriber);
    usingServer = hasSubscriber;
    if (hasSubscriber) {
      setParticipantCrumb();
      queue = (Array.isArray(data.queue) ? data.queue : [])
        .map(normaliseItem).filter(Boolean);
    } else {
      queue = readTemp();
    }
  }

  /* Re-sync after a failed optimistic mutation — server truth wins. */
  function resync() {
    statePromise = null;
    return getSubscriberState({ force: true });
  }

  /* ───── getSubscriberState() ─────
     Cached single GET /api/drop/state/{customerId}. Resolves the
     state payload ({ subscriber, queue, … }) or null. NO network for:
       - guests (no customerId to look up),
       - pages where Drop UI is unavailable (flag off, no tester).
     A found subscriber auto-merges any local pre-queue via
     syncLocal() — covers guest → login → already-a-subscriber. */
  function getSubscriberState(opts) {
    opts = opts || {};
    if (!opts.force && statePromise) return statePromise;
    if (!isLoggedIn() || !dropAvailable()) {
      return Promise.resolve(null);
    }
    statePromise = apiFetch('/api/drop/state/' + encodeURIComponent(currentCustomerId()))
      .then(function (data) {
        adoptServerState(data);
        var after = Promise.resolve();
        if (usingServer && readTemp().length > 0) {
          /* Subscriber exists AND a pre-queue is lingering — merge it
             server-side, then adopt the merged queue. Failures keep
             the local scratch for a later retry. */
          after = syncLocal().then(null, function () {});
        }
        return after.then(function () {
          emitQueue('state', { state: serverState ? clone(serverState) : null });
          return serverState;
        });
      })
      .catch(function () {
        statePromise = null; // transient failure — allow a retry
        return null;
      });
    return statePromise;
  }

  /* Sync accessor for painters — last-resolved state or null. */
  function getCachedState() {
    return serverState ? clone(serverState) : null;
  }
  function getSubscriber() {
    return (serverState && serverState.subscriber) ? clone(serverState.subscriber) : null;
  }

  /* ───── Queue API (kitProgress method parity) ───── */

  /* P5.5 Wide Fit preference — one shared reader for every gate
     (addItem below, the lane modal's panel note, painters welcome to
     migrate). Subscriber row first (server-authoritative, survives
     wizard-state clearing), wizard localStorage second (pre-subscriber
     browsers). Anything unknown → 'any' (no gate). */
  function getWideFitPref() {
    try {
      var sub = getSubscriber();
      var v = sub && sub.preferences && sub.preferences.wideFit;
      if (v === 'only' || v === 'none' || v === 'any') return v;
      var st = JSON.parse(localStorage.getItem('hgn-drop-wizard-state') || 'null');
      v = st && st.preferences && st.preferences.wideFit;
      return (v === 'only' || v === 'none') ? v : 'any';
    } catch (e) { return 'any'; }
  }
  /* Detection mirrors buy-buttons / collection-chrome: tags are
     authoritative when present; the queue item shape carries no tags,
     so the live-catalogue title convention ('… - Wide Fit Wrap') plus
     the legacy '(JK)' token do the work. */
  function isWideFitItem(it) {
    var tags = it && it.tags;
    if (tags && tags.length) {
      for (var i = 0; i < tags.length; i++) {
        var tg = String(tags[i]).toLowerCase();
        if (tg.indexOf('wide fit') !== -1 || tg.indexOf('wide-fit') !== -1) return true;
      }
    }
    var ti = String((it && it.title) || '').toLowerCase();
    return ti.indexOf('wide fit') !== -1 || ti.indexOf('wide-fit') !== -1 || ti.indexOf('(jk)') !== -1;
  }

  function getQueue() { return clone(queue); }
  function queueLength() { return queue.length; }
  function hasItem(variantId) {
    var vid = String(variantId);
    return queue.some(function (it) { return it.variantId === vid; });
  }

  /* addItem(item) → Promise<{ ok, queued: 'server'|'local', reason? }>
     item: { variantId, productId, handle, title, image, priceCents,
     tier }. Dedupes by variantId; cap 60. Server mode POSTs
     /api/drop/queue/add; a 404 ("no subscriber" — row deleted since
     boot) falls back to the local pre-queue, per the worker contract. */
  function addItem(item) {
    var norm = normaliseItem(item);
    if (!norm) return Promise.resolve({ ok: false, reason: 'invalid-item' });
    if (hasItem(norm.variantId)) return Promise.resolve({ ok: false, reason: 'duplicate' });
    if (queue.length >= QUEUE_CAP) return Promise.resolve({ ok: false, reason: 'cap' });
    /* Lane integrity (R2) — a Nail Drop list is single-tier. The
       painters already withhold off-lane takeovers; this is the
       belt-and-braces client mirror of the worker's wrong-tier 400,
       so no stale paint can ever mix a queue. */
    var lane = getFocus();
    if (lane && norm.tier && norm.tier !== lane) {
      return Promise.resolve({ ok: false, reason: 'wrong-tier' });
    }
    /* Wide Fit preference (P5.5) — hard sub-category gate on the
       classic lane, the belt-and-braces mirror of the PDP / collection
       takeover withholds: no path into the queue (move-to-drop, stale
       paint, future modal-mediated adds) can queue a wrap the
       shopper's stated preference excludes. */
    if ((norm.tier || lane) === 'classic') {
      var wfPref = getWideFitPref();
      if (wfPref !== 'any') {
        var wfIs = isWideFitItem(norm);
        if ((wfPref === 'only' && !wfIs) || (wfPref === 'none' && wfIs)) {
          return Promise.resolve({ ok: false, reason: 'wide-fit-pref' });
        }
      }
    }
    norm.addedAt = norm.addedAt || Date.now();

    queue.push(norm);
    if (!usingServer) writeTemp(queue);
    emitQueue('add', { item: clone(norm) });

    if (!usingServer) return Promise.resolve({ ok: true, queued: 'local' });
    return apiFetch('/api/drop/queue/add', {
      method: 'POST',
      body: {
        customerId: currentCustomerId(),
        item: {
          variantId:  norm.variantId,
          productId:  norm.productId,
          handle:     norm.handle,
          title:      norm.title,
          image:      norm.image,
          priceCents: norm.priceCents,
          tier:       norm.tier
        }
      }
    }).then(function () {
      return { ok: true, queued: 'server' };
    }).catch(function (err) {
      if (err && err.status === 404) {
        /* Subscriber row vanished — demote to pre-queue mode keeping
           the optimistic add (it's already in `queue`). */
        usingServer = false;
        serverState = null;
        writeTemp(queue);
        return { ok: true, queued: 'local' };
      }
      if (err && err.status === 400 && err.body && err.body.error === 'wrong-tier') {
        /* Worker refused the add (lane integrity). Revert the
           optimistic push and hand the server's message to the caller
           for the flash/toast. */
        queue = queue.filter(function (it) { return it.variantId !== norm.variantId; });
        emitQueue('remove', { variantId: norm.variantId });
        return { ok: false, reason: 'wrong-tier', message: err.body.message || '' };
      }
      return resync().then(function () { return { ok: false, reason: 'server' }; });
    });
  }

  function removeItem(variantId) {
    var vid = String(variantId);
    var before = queue.length;
    queue = queue.filter(function (it) { return it.variantId !== vid; });
    if (queue.length === before) return Promise.resolve({ ok: false, reason: 'not-found' });
    if (!usingServer) writeTemp(queue);
    emitQueue('remove', { variantId: vid });

    if (!usingServer) return Promise.resolve({ ok: true, queued: 'local' });
    return apiFetch('/api/drop/queue/remove', {
      method: 'DELETE',
      body: { customerId: currentCustomerId(), variantId: vid }
    }).then(function () {
      return { ok: true, queued: 'server' };
    }).catch(function () {
      return resync().then(function () { return { ok: false, reason: 'server' }; });
    });
  }

  /* reorder(orderedIds) — orderedIds are variantId strings (the
     client-facing identity everywhere else in this API). Listed items
     lead in the given order; anything unlisted keeps its relative
     order behind them.

     WORKER CONTRACT (fix F1): PUT /api/drop/queue/reorder matches
     QUEUE-ITEM ids (queue_items.id), NOT variantIds — posting
     variantIds is a silent no-op server-side and boxes would ship in
     the old order. So the server payload is translated from the
     locally-reordered queue via each item's `queueItemId` (retained
     by normaliseItem from the state fetch), and the response's
     `queue` is adopted as the new local truth. Any item missing a
     queueItemId (stale optimistic add mid-flight) forces a resync
     instead of sending a payload the worker would half-match. */
  function reorder(orderedIds) {
    if (!Array.isArray(orderedIds)) return Promise.resolve({ ok: false, reason: 'invalid' });
    var ids = orderedIds.map(String);
    var byId = {};
    queue.forEach(function (it) { byId[it.variantId] = it; });
    var next = [];
    ids.forEach(function (vid) {
      if (byId[vid]) { next.push(byId[vid]); delete byId[vid]; }
    });
    queue.forEach(function (it) {
      if (byId[it.variantId]) next.push(it);
    });
    queue = next;
    if (!usingServer) writeTemp(queue);
    emitQueue('reorder', { orderedIds: ids.slice() });

    if (!usingServer) return Promise.resolve({ ok: true, queued: 'local' });
    var orderedItemIds = [];
    var missingItemId = false;
    queue.forEach(function (it) {
      if (it.queueItemId) orderedItemIds.push(String(it.queueItemId));
      else missingItemId = true;
    });
    if (missingItemId) {
      return resync().then(function () { return { ok: false, reason: 'stale-ids' }; });
    }
    return apiFetch('/api/drop/queue/reorder', {
      method: 'PUT',
      body: { customerId: currentCustomerId(), orderedIds: orderedItemIds }
    }).then(function (data) {
      /* Adopt the server's post-reorder queue when returned so the
         local order can never drift from what will actually ship. */
      if (data && Array.isArray(data.queue)) {
        queue = data.queue.map(normaliseItem).filter(Boolean);
        if (serverState) serverState.queue = data.queue;
        emitQueue('reorder-adopted');
      }
      return { ok: true, queued: 'server' };
    }).catch(function () {
      return resync().then(function () { return { ok: false, reason: 'server' }; });
    });
  }

  /* syncLocal() — merge the pre-queue into the subscriber's server
     queue (POST /api/drop/queue/sync-local, mirroring the wishlist's
     sync-local). No-op resolve when there's nothing to merge or no
     one to merge into. Clears the scratch only on success. */
  function syncLocal() {
    var temp = readTemp();
    if (temp.length === 0) return Promise.resolve({ ok: true, merged: 0 });
    if (!isLoggedIn()) return Promise.resolve({ ok: false, reason: 'guest' });
    return apiFetch('/api/drop/queue/sync-local', {
      method: 'POST',
      body: {
        customerId: currentCustomerId(),
        items: temp.map(function (it) {
          return {
            variantId:  it.variantId,
            productId:  it.productId,
            handle:     it.handle,
            title:      it.title,
            image:      it.image,
            priceCents: it.priceCents,
            tier:       it.tier
          };
        })
      }
    }).then(function (data) {
      writeTemp([]);
      /* Lane-integrity refusals (fix F4): the worker skips off-tier
         scratch items and reports how many via `tierRejected` — carry
         it on the event + resolve so the side-cart section can tell
         the shopper instead of silently dropping their saves. */
      var tierRejected = (data && typeof data.tierRejected === 'number') ? data.tierRejected : 0;
      if (data && Array.isArray(data.queue)) {
        usingServer = true;
        queue = data.queue.map(normaliseItem).filter(Boolean);
        if (serverState) serverState.queue = data.queue;
        emitQueue('sync-local', { tierRejected: tierRejected });
        return { ok: true, merged: temp.length, tierRejected: tierRejected };
      }
      /* Response didn't carry the merged queue — re-fetch state. */
      return resync().then(function () {
        if (tierRejected > 0) emitQueue('sync-local', { tierRejected: tierRejected });
        return { ok: true, merged: temp.length, tierRejected: tierRejected };
      });
    }).catch(function (err) {
      if (err && err.status === 404) {
        /* No subscriber yet — scratch stays for the wizard (P5). */
        return { ok: false, reason: 'no-subscriber' };
      }
      return { ok: false, reason: 'server' };
    });
  }

  /* ───── Stock check ─────
     Single batched POST /api/drop/queue/stock-check. Resolves
     { '<variantId>': { inStock, quantity } }. Cached 60s per id-set
     so a render storm can't fan out duplicate calls. */
  var stockCache = { key: null, at: 0, data: null };
  var STOCK_TTL_MS = 60 * 1000;
  function stockCheck(variantIds) {
    var ids = (variantIds || []).map(String).filter(Boolean);
    if (ids.length === 0) return Promise.resolve({});
    var key = ids.slice().sort().join(',');
    if (stockCache.key === key && (Date.now() - stockCache.at) < STOCK_TTL_MS) {
      return Promise.resolve(stockCache.data);
    }
    return apiFetch('/api/drop/queue/stock-check', {
      method: 'POST',
      body: { variantIds: ids }
    }).then(function (data) {
      var stock = (data && data.stock) || {};
      stockCache = { key: key, at: Date.now(), data: stock };
      return stock;
    }).catch(function () { return {}; });
  }

  /* Subscribe sugar — mirrors kitProgress.subscribe. */
  function subscribe(handler) {
    if (typeof handler !== 'function') return function () {};
    var wrapped = function (e) { handler(e.detail || {}); };
    document.addEventListener('hgn:drop:change', wrapped);
    return function () { document.removeEventListener('hgn:drop:change', wrapped); };
  }

  /* Cross-tab pre-queue sync. */
  window.addEventListener('storage', function (e) {
    if (e.key !== TEMP_KEY || usingServer) return;
    queue = readTemp();
    emitQueue('storage');
  });

  window.HGN = window.HGN || {};
  window.HGN.dropQueue = {
    addItem:             addItem,
    getWideFitPref:      getWideFitPref,
    removeItem:          removeItem,
    hasItem:             hasItem,
    getQueue:            getQueue,
    queueLength:         queueLength,
    reorder:             reorder,
    subscribe:           subscribe,
    isTierEnabled:       isTierEnabled,
    getFocus:            getFocus,
    setFocus:            setFocus,
    getSubscriberState:  getSubscriberState,
    getCachedState:      getCachedState,
    getSubscriber:       getSubscriber,
    hasParticipantCrumb: hasParticipantCrumb,
    syncLocal:           syncLocal,
    stockCheck:          stockCheck,
    DROP_TIERS:          DROP_TIERS.slice(),
    QUEUE_CAP:           QUEUE_CAP
  };
})();
